import { Component, OnInit } from '@angular/core';
import { AccountService } from 'api-services';
import { DashboardNotificationService } from 'api-services/dashboard-notification.service';
import { BannerNotification } from 'models/dashboard-notification.model';
import moment from 'moment';
import { SystemSetting } from 'shared/constant';

@Component({
  selector: 'app-banner-notification',
  templateUrl: './banner-notification.component.html',
  styleUrls: ['./banner-notification.component.css']
})
export class BannerNotificationComponent implements OnInit {
  isCollapsed: boolean = true;
  notificationList: BannerNotification[] = [] as BannerNotification[];
  closedNotifications: any = [];
  hideNotificationTime: number = 0;

  constructor(private dashboardNotificationService: DashboardNotificationService, private accountService: AccountService) { }

  ngOnInit() {
    this.getSystemSettings().then(() => {
      this.getNotifications();
    });


  }

  getSystemSettings() {
    return new Promise((resolve) => {
      this.accountService.getSystemSettingByKey(SystemSetting.HideBannerNotificationDuration).subscribe(res => {
        this.hideNotificationTime = Number(res.value ?? 0);
        resolve(null);
      }, err => {
        console.log(err);
        resolve(null);
      })

    })
  }

  getNotifications() {
    this.closedNotifications = JSON.parse(localStorage.getItem('closedNotifications') || '[]');

    const now = moment();

    // Remove entries whose hide time has expired
    this.closedNotifications = this.closedNotifications.filter(
      closed => now.diff(moment(Number(closed.closedTime)), 'hours') < this.hideNotificationTime
    );

    // Update localStorage
    localStorage.setItem('closedNotifications', JSON.stringify(this.closedNotifications));

    this.dashboardNotificationService.getNotification().subscribe((response: any) => {
      this.notificationList = response.filter(notification => {
        const closed = this.closedNotifications.find(
          x => x.bannerNotificationId === notification.bannerNotificationId
        );

        // Show notification if it is not currently closed
        return !closed;
      });
    }, err => {
      console.log(err);
    });
  }

  get visibleNotifications() {
    if (this.isCollapsed) {
      return this.notificationList.slice(0, 3);
    }
    return this.notificationList;
  }

  closeNotification(notificationId: number) {
    this.notificationList = this.notificationList.filter(n => n.bannerNotificationId !== notificationId);

    // set closed notification Id for 24 hours
    this.closedNotifications.push({
      bannerNotificationId: notificationId,
      closedTime: moment().valueOf()
    });
    localStorage.setItem('closedNotifications', JSON.stringify(this.closedNotifications));

  }

  collapseToggle() {
    this.isCollapsed = !this.isCollapsed;
  }
}
